import MaterialToolbar from "@mui/material/Toolbar";
import { memo } from "react";

import { Skeleton } from "@mui/material";
import { Box } from "../../common/components";
import { createStyles, palette, spacing } from "../../styles/theme";
import { useThemeBreakpoints } from "../../utils/themeUtils";

export const STUDIO_TOOLBAR_HEIGHT = "48px";

const styles = createStyles({
  toolbar: {
    minHeight: STUDIO_TOOLBAR_HEIGHT,
    maxHeight: STUDIO_TOOLBAR_HEIGHT,
    background: "white",
    boxShadow: "none",
    borderBottom: `1px solid ${palette.grey.lightGrey}`,
    display: "flex",
    justifyContent: "space-between",
    px: { xs: spacing.wrapperMobile, md: spacing.mediumDesktop },
    minWidth: "100%",
  },
});

const StudioToolbarSkeleton = () => {
  const { isMobile } = useThemeBreakpoints();

  return (
    <MaterialToolbar disableGutters={true} style={styles.toolbar}>
      <Box display={"flex"} gap={spacing.mediumDesktop} alignItems={"center"}>
        <Skeleton
          variant="rounded"
          width={32}
          height={32}
          sx={{ borderRadius: "100%" }}
        />
        {!isMobile && <Skeleton variant="text" width={150} height={24} />}
      </Box>
      <Box display={"flex"} gap={spacing.ctaSpacingDesktop}>
        <Skeleton
          variant="text"
          sx={{ width: { xs: 50, lg: 125 } }}
          height={32}
        />
        <Skeleton
          variant="text"
          sx={{ width: { xs: 50, lg: 125 } }}
          height={32}
        />
        <Skeleton
          variant="text"
          sx={{ width: { xs: 50, lg: 125 } }}
          height={32}
        />
      </Box>
      <Box display={"flex"} gap={spacing.ctaSpacingDesktop}>
        <Skeleton
          variant="rounded"
          width={32}
          height={32}
          sx={{ borderRadius: "100%" }}
        />
        {!isMobile && (
          <Skeleton
            variant="rounded"
            width={100}
            height={32}
            sx={{ borderRadius: "8px" }}
          />
        )}
      </Box>
    </MaterialToolbar>
  );
};
export default memo(StudioToolbarSkeleton);
